import type { ReactNode } from 'react';

import type { TProgressIndicatorElement } from '@shared/dream-components';
import { ProgressIndicatorElement } from '@shared/dream-components';

import { usePostPageContext } from '~/context/usePostPageContext';
import useScrollPosition from '~/hooks/useScrollPosition';

interface Props {
  node: TProgressIndicatorElement;
  children: ReactNode | ReactNode[];
}

const ProgressIndicator = ({ node, children }: Props) => {
  const { isSubscriberGateEnabled, isEmailCapturePopupEnabled } = usePostPageContext() || {
    isSubscriberGateEnabled: false,
  };
  const { percentageScrolled } = useScrollPosition() || {
    percentageScrolled: 0,
    windowScrollY: 0,
  };
  const currentProgress = Number((percentageScrolled * 100).toFixed(1));

  if (isSubscriberGateEnabled || isEmailCapturePopupEnabled) {
    return null;
  }

  return (
    <div className="fixed top-0 z-50 w-full">
      <ProgressIndicatorElement element={node} currentProgress={currentProgress}>
        {children}
      </ProgressIndicatorElement>
    </div>
  );
};

export default ProgressIndicator;
